// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__rVXvw","header":"ReportDetails_header__3fkTa","title":"ReportDetails_title__23CT1","left":"ReportDetails_left__2wnmt"};